<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre19" id="pgepubid00027"><span class="calibre1">CHAPTER I</span> <span class="smaller1">DEPORTATION TO RUSSIA</span></h2>
<p class="calibre7">On the night of December 21, 1919, together with two hundred and
forty-eight other political prisoners, I was deported from America.
Although it was generally known we were to be deported, few really
believed that the United States would so completely deny her past as
an asylum for political refugees, some of whom had lived and worked in
America for more than thirty years.</p>
<p class="calibre7">In my own case, the decision to eliminate me first became known when,
in 1909, the Federal authorities went out of their way to disfranchise
the man whose name gave me citizenship. That Washington waited till
1917 was due to the circumstance that the psychologic moment for the
finale was lacking. Perhaps I should have <span id="pgepubid00028" title="[Pg 2]"><a id="Page_2" title="[Pg 2]"></a></span>contested my case at that
time. With the then-prevalent public opinion, the Courts would probably
not have sustained the fraudulent proceedings which robbed me of
citizenship. But it did not seem credible then that America would stoop
to the Tsaristic method of deportation.</p>
<p class="calibre7">Our anti-war agitation added fuel to the war hysteria of 1917, and
thus furnished the Federal authorities with the desired opportunity to
complete the conspiracy begun against me in Rochester, N. Y., 1909.</p>
<p class="calibre7">It was on December 5, 1919, while in Chicago lecturing, that I was
telegraphically apprised of the fact that the order for my deportation
was final. The question of my citizenship was then raised in court, but
was of course decided adversely. I had intended to take the case to a
higher tribunal, but finally I decided to carry the matter no further:
Soviet Russia was luring me.</p>
<p class="calibre7">Ludicrously secretive were the authorities about our deportation. To
the very last moment we were kept in ignorance as to the time. Then,
unexpectedly, in the wee small hours of December 21st we were spirited
away. The scene set for this performance was most thrilling. It was six
o'clock Sunday morning, December<span id="pgepubid00029" title="[Pg 3]"><a id="Page_3" title="[Pg 3]"></a></span> 21, 1919, when under heavy military
convoy we stepped aboard the <i class="calibre18">Buford</i>.</p>
<p class="calibre7">For twenty-eight days we were prisoners. Sentries at our cabin doors
day and night, sentries on deck during the hour we were daily permitted
to breathe the fresh air. Our men comrades were cooped up in dark,
damp quarters, wretchedly fed, all of us in complete ignorance of the
direction we were to take. Yet our spirits were high—Russia, free, new
Russia was before us.</p>
<p class="calibre7">All my life Russia's heroic struggle for freedom was as a beacon to me.
The revolutionary zeal of her martyred men and women, which neither
fortress nor <i class="calibre18">katorga</i> could suppress, was my inspiration in the
darkest hours. When the news of the February Revolution flashed across
the world, I longed to hasten to the land which had performed the
miracle and had freed her people from the age-old yoke of Tsarism. But
America held me. The thought of thirty years of struggle for my ideals,
of my friends and associates, made it impossible to tear myself away. I
would go to Russia later, I thought.</p>
<p class="calibre7">Then came America's entry into the war and the need of remaining true
to the American people who were swept into the hurricane against<span id="pgepubid00030" title="[Pg 4]"><a id="Page_4" title="[Pg 4]"></a></span> their
will. After all, I owed a great debt, I owed my growth and development
to what was finest and best in America, to her fighters for liberty, to
the sons and daughters of the revolution to come. I would be true to
them. But the frenzied militarists soon terminated my work.</p>
<p class="calibre7">At last I was bound for Russia and all else was almost blotted out.
I would behold with mine own eyes <i class="calibre18">matushka Rossiya</i>, the land freed
from political and economic masters; the Russian <i class="calibre18">dubinushka</i>, as the
peasant was called, raised from the dust; the Russian worker, the
modern Samson, who with a sweep of his mighty arm had pulled down the
pillars of decaying society. The twenty-eight days on our floating
prison passed in a sort of trance. I was hardly conscious of my
surroundings.</p>
<p class="calibre7">Finally we reached Finland, across which we were forced to journey in
sealed cars. On the Russian border we were met by a committee of the
Soviet Government, headed by Zorin. They had come to greet the first
political refugees driven from America for opinion's sake.</p>
<p class="calibre7">It was a cold day, with the earth a sheet of white, but spring was in
our hearts. Soon we were to behold revolutionary Russia. I preferred to
be alone when I touched the sacred<span id="pgepubid00031" title="[Pg 5]"><a id="Page_5" title="[Pg 5]"></a></span> soil: my exaltation was too great,
and I feared I might not be able to control my emotion. When I reached
Beloöstrov the first enthusiastic reception tendered the refugees was
over, but the place was still surcharged with intensity of feeling. I
could sense the awe and humility of our group who, treated like felons
in the United States, were here received as dear brothers and comrades
and welcomed by the Red soldiers, the liberators of Russia.</p>
<p class="calibre7">From Beloöstrov we were driven to the village where another reception
had been prepared: A dark hall filled to suffocation, the platform lit
up by tallow candles, a huge red flag, on the stage a group of women in
black nuns' attire. I stood as in a dream in the breathless silence.
Suddenly a voice rang out. It beat like metal on my ears and seemed
uninspired, but it spoke of the great suffering of the Russian people
and of the enemies of the Revolution. Others addressed the audience,
but I was held by the women in black, their faces ghastly in the yellow
light. Were these really nuns? Had the Revolution penetrated even the
walls of superstition? Had the Red Dawn broken into the narrow lives of
these ascetics? It all seemed strange, fascinating.</p>
<p class="calibre7"><span id="pgepubid00032" title="[Pg 6]"><a id="Page_6" title="[Pg 6]"></a></span></p>
<p class="calibre7">Somehow I found myself on the platform. I could only blurt out that
like my comrades I had not come to Russia to teach: I had come to
learn, to draw sustenance and hope from her, to lay down my life on the
altar of the Revolution.</p>
<p class="calibre7">After the meeting we were escorted to the waiting Petrograd train,
the women in the black hood intoning the "Internationale," the whole
audience joining in. I was in the car with our host, Zorin, who had
lived in America and spoke English fluently. He talked enthusiastically
about the Soviet Government and its marvellous achievements. His
conversation was illuminative, but one phrase struck me as discordant.
Speaking of the political organization of his Party, he remarked:
"Tammany Hall has nothing on us, and as to Boss Murphy, we could teach
him a thing or two." I thought the man was jesting. What relation could
there be between Tammany Hall, Boss Murphy, and the Soviet Government?</p>
<p class="calibre7">I inquired about our comrades who had hastened from America at the
first news of the Revolution. Many of them had died at the front,
Zorin informed me, others were working with the Soviet Government. And
Shatov? William Shatov, a brilliant speaker and able organizer,<span id="pgepubid00033" title="[Pg 7]"><a id="Page_7" title="[Pg 7]"></a></span> was
a well-known figure in America, frequently associated with us in our
work. We had sent him a telegram from Finland and were much surprised
at his failure to reply. Why did not Shatov come to meet us? "Shatov
had to leave for Siberia, where he is to take the post of Minister of
Railways," said Zorin.</p>
<p class="calibre7">In Petrograd our group again received an ovation. Then the deportees
were taken to the famous Tauride Palace, where they were to be fed
and housed for the night. Zorin asked Alexander Berkman and myself to
accept his hospitality. We entered the waiting automobile. The city was
dark and deserted; not a living soul to be seen anywhere. We had not
gone very far when the car was suddenly halted, and an electric light
flashed into our eyes. It was the militia, demanding the password.
Petrograd had recently fought back the Yudenitch attack and was still
under martial law. The process was repeated frequently along the route.
Shortly before we reached our destination we passed a well-lighted
building. "It is our station house," Zorin explained, "but we have
few prisoners there now. Capital punishment is abolished and we have
recently proclaimed a general political amnesty."</p>
<p class="calibre7"><span id="pgepubid00034" title="[Pg 8]"><a id="Page_8" title="[Pg 8]"></a></span></p>
<p class="calibre7">Presently the automobile came to a halt. "The First House of the
Soviets," said Zorin, "the living place of the most active members
of our Party." Zorin and his wife occupied two rooms, simply but
comfortably furnished. Tea and refreshments were served, and our hosts
entertained us with the absorbing story of the marvellous defence
the Petrograd workers had organized against the Yudenitch forces.
How heroically the men and women, even the children, had rushed to
the defence of the Red City! What wonderful self-discipline and
coöperation the proletariat demonstrated. The evening passed in these
reminiscences, and I was about to retire to the room secured for me
when a young woman arrived who introduced herself as the sister-in-law
of "Bill" Shatov. She greeted us warmly and asked us to come up to
see her sister who lived on the floor above. When we reached their
apartment I found myself embraced by big jovial Bill himself. How
strange of Zorin to tell me that Shatov had left for Siberia! What did
it mean? Shatov explained that he had been ordered not to meet us at
the border, to prevent his giving us our first impressions of Soviet
Russia. He had fallen into disfavour with the Government and was being
sent to<span id="pgepubid00035" title="[Pg 9]"><a id="Page_9" title="[Pg 9]"></a></span> Siberia into virtual exile. His trip had been delayed and
therefore we still happened to find him.</p>
<p class="calibre7">We spent much time with Shatov before he left Petrograd. For whole days
I listened to his story of the Revolution, with its light and shadows,
and the developing tendency of the Bolsheviki toward the right. Shatov,
however, insisted that it was necessary for all the revolutionary
elements to work with the Bolsheviki Government. Of course, the
Communists had made many mistakes, but what they did was inevitable,
imposed upon them by Allied interference and the blockade.</p>
<p class="calibre7">A few days after our arrival Zorin asked Alexander Berkman and myself
to accompany him to Smolny. Smolny, the erstwhile boarding school for
the daughters of the aristocracy, had been the centre of revolutionary
events. Almost every stone had played its part. Now it was the seat of
the Petrograd Government. I found the place heavily guarded and giving
the impression of a beehive of officials and government employees. The
Department of the Third International was particularly interesting. It
was the domain of Zinoviev. I was much impressed by the magnitude of it
all.</p>
<p class="calibre7"><span id="pgepubid00036" title="[Pg 10]"><a id="Page_10" title="[Pg 10]"></a></span></p>
<p class="calibre7">After showing us about, Zorin invited us to the Smolny dining room. The
meal consisted of good soup, meat and potatoes, bread and tea—rather a
good meal in starving Russia, I thought.</p>
<p class="calibre7">Our group of deportees was quartered in Smolny. I was anxious about my
travelling companions, the two girls who had shared my cabin on the
<i class="calibre18">Buford</i>. I wished to take them back with me to the First House of the
Soviet. Zorin sent for them. They arrived greatly excited and told
us that the whole group of deportees had been placed under military
guard. The news was startling. The people who had been driven out of
America for their political opinions, now in Revolutionary Russia again
prisoners—three days after their arrival. What had happened?</p>
<p class="calibre7">We turned to Zorin. He seemed embarrassed. "Some mistake," he said, and
immediately began to make inquiries. It developed that four ordinary
criminals had been found among the politicals deported by the United
States Government, and therefore a guard was placed over the whole
group. The proceeding seemed to me unjust and uncalled for. It was my
first lesson in Bolshevik methods.</p>
<p class="calibre7"><span id="pgepubid00037" title="[Pg 11]"><a id="Page_11" title="[Pg 11]"></a></span></p>
<div class="calibre23" id="calibre_pb_5"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0004.vue?032f54a0